import React from "react";
import { isSet } from "../../../../utils/commonUtils";
import FileManagerService from "../../../../services/FileManagerService";
import WithRoutify from "../../../../hoc/WithRoutify";

const NewFileType = (props)=>{
    
    const value = props.value;
    const downloadFile = async (value)=>{
        props.Loader(true);
      try {
        await FileManagerService.downloadFile(value,props.actionType);
        props.Loader(false);
        } catch (error) {
            console.log('Error downloading file:', error);
            props.Loader(false);
        }
    }
    return(
        <td>
            {(isSet(value.file_id,null)!==null)?
                <div className='sh_fileupload tdfile'>
                <a  className='sh_fileupload_link' href='#!' onClick={()=>downloadFile(value.file_id)} title={value.original_name}>{value.original_name}</a>
                </div>
                :<></>}
        </td>
    )
}
NewFileType.defaultProps ={
    changeHandler:()=>{},
    actionType:'download',
}

export default WithRoutify(NewFileType);